import L from 'leaflet';

export const VenueLocationIconMap = L.icon({
  iconUrl: require('../assets/dot_blue.svg'),
  iconRetinaUrl: require('../assets/dot_blue.svg'),
  iconAnchor: null,
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: [20, 15],
  className: 'leaflet-venue-icon'
});
